import { RichTextEditor, RichTextEditorProvider } from '@pba/react-rich-text-editor';
import { type ReactNode, useCallback, useState } from 'react';
import { Loading, message } from 'ui';

type P = {
  children: ReactNode;
};

const richTextEditorSettings = {
  // eslint-disable-next-line @typescript-eslint/unbound-method -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
  onError: message.error,
  translations: {
    colors: {
      black: 'Black',
      blue: 'Blue',
      gray: 'Gray',
      green: 'Green',
      orange: 'Orange',
      red: 'Red',
    },
    errors: {
      fileAccessFailed: 'Error during accessing file',
      fileUploadAborted: 'Abort file upload',
      fileUploadFailed: 'Error during file upload',
      sourceValidationFailed:
        'We cannot allow images from unknown sources for security reasons. Please use the regular upload method to submit your images.',
    },
    preview: 'Preview',
  },
};

const RichTextEditorProviderLicenseGate = ({ children }: P) => {
  const [isEditorReady, setIsEditorReady] = useState(false);

  const onFinish = useCallback(() => {
    setIsEditorReady(true);
  }, []);

  return (
    <RichTextEditorProvider value={richTextEditorSettings}>
      {isEditorReady ? (
        children
      ) : (
        <>
          <Loading viewportHeight />
          <div className="provider-license-gate">
            <RichTextEditor onError={onFinish} onReady={onFinish} />
          </div>
        </>
      )}
    </RichTextEditorProvider>
  );
};

export default RichTextEditorProviderLicenseGate;
